import { RRule } from 'rrule'
import moment from 'moment-timezone'
import { cloneDeep } from 'lodash'

export const CalendarItems = (item: any, calendar_items_recurring: Array<any>) => {
    const rule = new RRule({
        freq: RRule.WEEKLY,
        interval: item.interval,
        byweekday: item.byweekday,
        dtstart: new Date(moment.tz(item.dtstart, 'UTC').valueOf()),
        until: item.until
    });
      
    const weekstart = moment().startOf('isoWeek').subtract(1, 'week');
    const weekend = moment().endOf('isoWeek');
      
    let occurences = rule.between(new Date(weekstart.valueOf()), new Date(weekend.valueOf()));
  
    occurences.forEach((dtstart, index) => {
      let cloned_item :any = cloneDeep(item);
      cloned_item.dtstart = new Date(moment(moment(dtstart).utc().format('YYYY-MM-DD HH:mm:ss')).valueOf());
      
      // React big calendar has a bug (IMO) and fails to display periods that 
      // end at midnight. The end is change to 23:59 to get around this for now
      let end = moment(cloned_item.dtstart.valueOf() + ((cloned_item.duration) * 1000) );
      if (end.format('HH:mm:ss') === '00:00:00') {
        end.subtract(1, 'minute');
      }
      
      cloned_item.end = end.toDate();
      calendar_items_recurring.push(cloned_item);
    })

    return calendar_items_recurring;
}